import "whatwg-fetch"; // polyfill for older browsers

import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

var analyticsAdapter = {
  /***********
  API Requests
  ***********/

  // get push notifications from the DB
  fetchPushNotifications: async () => {
    let query = {
      order_by: "desc",
      since: "2016-01-01T00:00:00-04:00",
    };
    const apiConfig = getAPIConfig(
      `/analytics/pn/pn_details${convertQueryObjToString(query)}`
    );
    const response = await executeAPIRequest(apiConfig, "GET");
    try {
      const getData = await response.json();
      return getData;
    } catch (err) {
      console.log("(api) error fetching pnDetails");
      return [];
    }
  },

  fetchPushNotificationOptIns: async () => {
    const apiConfig = getAPIConfig(`/analytics/pn/pn_optins`);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchBannerStat: (banner_id) => {
    const apiConfig = getAPIConfig("/analytics/visits/banner");

    let query = {
      banner_id: banner_id,
    };

    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + apiConfig.jwtToken,
    };

    return fetch(apiConfig.url + convertQueryObjToString(query), {
      headers: headers,
      method: "GET",
      dataType: "json",
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          return { error: true };
        }
      })
      .then((json) => {
        if (json.error) {
          return {
            results: null,
            error: true,
          };
        } else {
          return {
            results: json,
            error: false,
          };
        }
      })
      .catch((err) => {
        console.log("Error fetching data.");
        console.log(err);
        return {
          results: null,
          error: true,
        };
      });
  },

  fetchPromotionStat: (grpid) => {
    const apiConfig = getAPIConfig("/analytics/visits/offer");

    let query = {
      grpid: grpid,
    };

    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + apiConfig.jwtToken,
    };

    return fetch(apiConfig.url + convertQueryObjToString(query), {
      headers: headers,
      method: "GET",
      dataType: "json",
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          return { error: true };
        }
      })
      .then((json) => {
        if (json.error) {
          return {
            results: null,
            error: true,
          };
        } else {
          return {
            results: json,
            error: false,
          };
        }
      })
      .catch((err) => {
        console.log("Error fetching data.");
        console.log(err);
        return {
          results: null,
          error: true,
        };
      });
  },
};

window.analyticsAdapter = analyticsAdapter;

export default analyticsAdapter;
